import firebase from "firebase/app";
import "firebase/firestore"; // If using Firebase database
import "firebase/auth"; // If using Firebase database
import { FIREBASE_CONFIG } from "../constants";

firebase.initializeApp(FIREBASE_CONFIG);

export default firebase;
